export const containsSpecialChars = (text) => {
  const expression = /[~`!@#$%^&*()+=[\]{};':"\\|,.<>\\/?]+/;
  return expression.test(text);
};
